import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconIntegrations({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M4 3h8a1 1 0 0 1 1 1v2.122l-2.025 2.025a2.5 2.5 0 1 0-2.829 2.829L6.122 13H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm3.536 10H12a1 1 0 0 0 1-1V7.536l-1.672 1.671a.5.5 0 0 1-.707 0l-.465-.465a.612.612 0 0 1-.162-.382A1.5 1.5 0 1 0 8.36 9.993c.14.014.28.062.38.163l.466.466a.5.5 0 0 1 0 .707L7.536 13zM2 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4z"/>
        </svg>
    );
}

export default IconIntegrations;
